<template>
  <div
    class="avatar-custom"
    :class="`${bg ? 'bg' : ''} ${status ? 'active' : ''} s-${size}`"
    :style="style"
  >
    <img
      v-if="ai"
      class="aiIcon"
      :src="require('@/assets/images/ai.png')"
    >
    <div v-else>
      {{ text | filterText }}
    </div>
    <slot />
  </div>
</template>

<script>
export default {
  name: 'AvatarCustom',
  filters: {
    filterText(val) {
      if (!val) return ''
      return val.length <= 2 ? val : val.substring(val.length - 2, val.length)
    }
  },
  props: {
    text: {
      type: String,
      default: () => ''
    },
    bg: {
      type: Boolean,
      default: () => false
    },
    size: {
      type: Number,
      default: () => null
    },
    status: {
      type: Boolean,
      default: () => false
    },
    ai: {
      type: Boolean,
      default: () => false
    }
  },
  computed: {
    style() {
      const backgroundGradient = [
        'linear-gradient(46deg, #7729F5 0%, #CD8DFF 100%) rgba(0,0,0,0.2)',
        'linear-gradient(46deg, #295EF5 0%, #8DABFF 100%)',
        'linear-gradient(227deg, #FFB546 0%, #EE883E 100%)',
        'linear-gradient(46deg, #3FB9D3 0%, #54EFE6 100%)'
      ]
      if (this.ai) {
        return `background: rgba(44,104,255,0.1);`
      }
      const key = `local_background_${this.text}`
      const avatarBackground = this.$store.getters.avatarBackground
      const bgIndex = avatarBackground[key]
      if (bgIndex !== undefined) {
        return !this.bg ? `background: ${backgroundGradient[bgIndex]}` : ''
      } else {
        let values = Object.values(avatarBackground).sort((pre, after) => after - pre)
        if (values.length === 0) {
          values = [0]
        }
        let a = values[0] + 1
        if (a > 3) {
          a = Math.floor(Math.random() * (0 - 2)) + 3
        }
        avatarBackground[key] = a
        if (this.text) {
          this.$store.dispatch('customAvatar/setBackground', avatarBackground)
        }
        return !this.bg ? `background: ${backgroundGradient[a]}` : ''
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.avatar-custom {
  position: relative;
  width: 80px;
  height: 80px;
  opacity: 1;
  border-radius: 99px;
  display: flex;
  align-items: center;
  justify-content: center;
  .aiIcon {
    width: 28px;
    height: 28px;
  }
  &.s-36 {
    width: 50px;
    height: 50px;
    >div {
      font-size: 14px;
    }
  }
  &.active {
    position: relative;
    &::after {
      display: block;
      content: '';
      position: absolute;
      right: 0;
      bottom: 0;
      width: 26px;
      height: 26px;
      background: url("@/assets/images/gou.png") center center no-repeat;
      background-size: 100%;
    }
  }
  &.bg {
    background: url("@/assets/images/avatar-border.png") center center no-repeat;
    background-size: 100%;
    div {
      width: 70px;
      height: 70px;
      line-height: 70px;
      background: linear-gradient(46deg, #295EF5 0%, #8DABFF 100%);
    }
  }
  >div {
    text-align: center;
    opacity: 1;
    border-radius: 50%;
    font-size: 28px;
    font-family: PingFang SC-Medium, PingFang SC;
    font-weight: 500;
    color: #FFFFFF;
  }
}
</style>
